import { CreateFolderDTO } from '@fenix/file-manager-entities/file-manager-entities/';
import { AxiosInstance } from 'axios';
import FolderRepositoryInterface from '@/services/File-manager/interfaces/folder.interface';
import { FolderEntity } from '@fenix/file-manager-entities/file-manager-entities/entitites';

export default class FolderRepository implements FolderRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  async createFolder(createDTO: CreateFolderDTO): Promise<FolderEntity> {
    const url = 'internal-file-manager/folders';
    const res = await this.axios.post(url, createDTO);

    return res.data;
  }

  async getRootFolders(): Promise<FolderEntity[]> {
    const url = '/internal-file-manager/folders';
    const res = await this.axios.get(url);

    return res.data;
  }

  async getFolder(id: number | string): Promise<FolderEntity> {
    const url = `/internal-file-manager/folders/${id}`;
    const res = await this.axios.get(url);

    return res.data;
  }

  async deleteFolder(id: number | string): Promise<void> {
    const url = `/internal-file-manager/folders/${id}`;
    await this.axios.delete(url);
  }
}
